import { useState, useEffect } from 'react';
import { useUserContextApi } from '../context/UserContext';
import { useConfigContext } from '../context/ConfigContext';
import { useNavigate } from 'react-router';
import { getApiBaseUrl } from './apiBase';

export default function useFetchScreenDetails(appid) {
  const navigate = useNavigate();
  const { userDetails, accessControlDetails, updateUserDetails } = useUserContextApi();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [details, setDetails] = useState(null);
  const [screenTables, setScreenTables] = useState(null);
  const { configSchema } = useConfigContext();
  const apiBase = getApiBaseUrl();

  useEffect(() => {
    if (accessControlDetails) {
      const appData = accessControlDetails.find((item) => {
        const screenNameId = item.mbdScreen.screenInternalName.toLowerCase().split(' ').join('_');
        return screenNameId === appid;
      });
      if (!appData) {
        navigate('/404');
        return;
      }
      const data = {
        ...userDetails,
        screenId: appData.screenId,
        appDetails: appData.mbdScreen,
      };
      setDetails(data);
      updateUserDetails(data);
      const { mbdScreen } = appData;
      fetch(`${apiBase}/api/screenDetails?` + new URLSearchParams({ menuName: mbdScreen.menuName }))
        .then((res) => res.json())
        .then((selectedScreen) => {
          const screenId = selectedScreen[`${configSchema}_mbd_screens`]?.[0];
          if (screenId)
            fetch(`${apiBase}/api/screenGridDetails?screenId=${screenId.id}`)
              .then((response) => {
                if (!response.ok) {
                  throw new Error('dataGrid API call failed.');
                }
                return response.json();
              })
              .then((screenTables) => {
                setScreenTables(screenTables[`${configSchema}_mbd_screen_to_data_grids`]);
                if (!screenTables[`${configSchema}_mbd_screen_to_data_grids`].length) {
                  setError(true);
                } else {
                  setError(false);
                }
              })
              .catch(() => {
                return setError(true);
              })
              .finally(() => setLoading(false));
        });
    }
  }, [appid, accessControlDetails]);

  return { loading, error, details, screenTables };
}
